import { TenantPackageConfig } from '~/tenants/common/registry';
import { MlmOrderContext, MlmOrderType } from '~/tenants/mlm/model/MlmOrder';
import MlmPhotosConfig from '~/tenants/mlm/performable/photos/MlmPhotosConfig';
import MlmFloorplanConfig from '~/tenants/mlm/performable/floorplan/MlmFloorplanConfig';
import MlmAerialConfig from '~/tenants/mlm/performable/aerial/MlmAerialConfig';
import Mlm3dConfig from '~/tenants/mlm/performable/3d/Mlm3dConfig';
import MlmWalkthroughConfig from '~/tenants/mlm/performable/walkthrough/MlmWalkthroughConfig';

const MlmStokedPackageConfig: TenantPackageConfig = {
  id: 'stoked',
  name: 'Stoked Sellers',
  description: '',
  amount: '305.00',
  performables: [MlmPhotosConfig, MlmFloorplanConfig, MlmAerialConfig, Mlm3dConfig, MlmWalkthroughConfig],
  eligible: (context) => (context as MlmOrderContext).metadata.type === MlmOrderType.RESIDENTIAL,
};

export default MlmStokedPackageConfig;
